import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import './PortfolioDetails.css';
import { NavLink } from 'react-router-dom';

const PortfolioDetails = () => {
    const { PorfoliosId } = useParams();
    const [details, setDetails] = useState({});
    useEffect(() => {
        const url = `https://calm-dawn-17727.herokuapp.com/projects/${PorfoliosId}`;
        fetch(url)
            .then(res => res.json())
            .then(data => {
               
                setDetails(data)}
            )
    }, [])

    return (
        <div className="container-fluid">
            <div class="row">
                <div class="col-lg-8 col-md-8 col-sm-12 large-imge">
                    <div class="card">
                        <div class="card-body">
                            <img src={details.img1} alt="" />
                        </div>
                    </div>
                    <hr />


                    <div className="align-left features-text">
                        <h1>Special features</h1>
                        <h5> <span className="fw-bold"> project name </span>  :{details.name}</h5>
                        <h5 className="fw-bold">What can do user ?</h5>
                        <h6> 1. {details.feature01}</h6>
                        <h6> 2. {details.feature02}</h6>
                        <h6> 3. {details.feature03}</h6>
                        <h6> <span className="fw-bold"> Technologies</span>  : {details.Technologies}</h6>
 <a href={details.liveLink} target="_blank"> <i class="fas fa-arrow-right">liveLink</i></a>
 <a href={details.githubClient} target="_blank"> <i class="fab fa-github">Github Client</i></a>
 <a href={details.githubServer} target="_blank"> <i class="fab fa-github">Github Server</i></a>

                    </div>

                </div>
                <div class="col-lg-4 col-md-4 col-sm-12 small-imge">
                    <div class="card">
                        <div class="card-body">
                            <img class="py-5" src={details.img} alt="" />
                            <img class="py-5" src={details.img2} alt="" />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default PortfolioDetails;